import React, { useState, useEffect, useMemo } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  CommandColumn,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
  Freeze,
} from "@syncfusion/ej2-react-grids";
import { useVendorMasterStore } from "../../../store/useVendorMasterStore";
import { message } from "antd";
import { MailFilled } from "@ant-design/icons";

const TriggerGrid = ({}) => {
  const { triggerList, sendReminder, loading } = useVendorMasterStore();
  const [loadings, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleResend = async (VendorGUID) => {
    try {
      setLoading(true);
      const response = await sendReminder(VendorGUID);
      if (response?.IsSuccess) {
        message.success(
          response?.DisplayMessage || "Reminder email sent successfully",
        );
      }
    } catch (error) {
      message.error("Failed to resend email.");
    } finally {
      setLoading(false);
    }
  };
  const actionTemplate = (row) => {
    return (
      <div style={{ display: "flex", gap: "6px", justifyContent: "center" }}>
        {/* Resend Button*/}
        {row?.Submitted !== "Yes" && (
          <button
            className="e-control e-btn e-flat e-primary"
            title="Send Reminder Email"
            onClick={(e) => {
              e.stopPropagation();
              row?.VendorGUID && handleResend(row?.VendorGUID);
            }}
            disabled={loadings}
          >
            <MailFilled style={{ fontSize: 18, color: "#e74c3c" }} />
          </button>
        )}
      </div>
    );
  };
  // const safeTriggerList = useMemo(
  //   () => (Array.isArray(triggerList) ? triggerList : []),
  //   [triggerList],
  // );
  const safeTriggerList = useMemo(() => {
  if (!Array.isArray(triggerList)) return [];

  return triggerList.map(item => ({
    ...item,
    CreatedOn: item.CreatedOn ? new Date(item.CreatedOn) : null,
  }));
}, [triggerList]);

  let gridInstance;

  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "BrokerGrid_excelexport") {
      gridInstance.excelExport();
    }
  };

  return (
    <>
      <div
        className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
        style={{
          position: "relative",
          marginTop: "10px",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "6px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col>
            {loading ? (
              <div style={{ textAlign: "center", padding: "40px 0" }}>
                Loading vendors...
              </div>
            ) : (
              <GridComponent
                ref={(g) => (gridInstance = g)}
                id="BrokerGrid"
                dataSource={safeTriggerList}
                allowPaging={true}
                allowSorting={true}
                allowFiltering={true}
                filterSettings={{ type: "Excel" }}
                toolbar={["ExcelExport", "Search"]}
                allowExcelExport={true}
                toolbarClick={toolbarClick}
                enableAdaptiveUI={isMobile}
                rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
                gridLines="Both"
                height={"300px"}
                pageSettings={{
                  pageSizes: [10, 20, 30, 40, 50, "All"],
                  pageCount: 10,
                }}
                rowHeight={isMobile ? "" : 32}
                allowResizing={true}
                dataBound={() => {
                  if (!isMobile && gridInstance) {
                    gridInstance.autoFitColumns();
                  }
                }}
                // frozenColumns={1}
                // rowDataBound={()}
                // commandClick={handleCommandClick}
              >
                <ColumnsDirective>
                  <ColumnDirective
                    field="serialNo"
                    headerText="S No"
                    width="70"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="VendorGUID"
                    headerText="GUID"
                    width="150"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="DivisionName"
                    headerText="Division Name"
                    width="150"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="DepartmentName"
                    headerText="Department Name"
                    width="150"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="VendorType"
                    headerText="Vendor Type"
                    width="200"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="VendorName"
                    headerText="Vendor Name"
                    width="300"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="UserName"
                    headerText="User Name"
                    width="250"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="EmailID"
                    headerText="Email ID"
                    width="150"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="Submitted"
                    headerText="Submitted"
                    width="150"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="CreatedOn"
                    headerText="Created On"
                    width="150"
                    textAlign="Left"
                    type="date"
                    format="dd/MM/yyyy"
                  />
                  <ColumnDirective
                    headerText="Actions"
                    // commands={userCommands}
                    width="120"
                    textAlign="Center"
                    freeze="Right"
                    template={actionTemplate}
                  />
                </ColumnsDirective>

                <Inject
                  services={[
                    CommandColumn,
                    Page,
                    Filter,
                    Toolbar,
                    ExcelExport,
                    Sort,
                    Group,
                    Resize,
                    Freeze,
                  ]}
                />
              </GridComponent>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default TriggerGrid;
